import { formatDate } from './format';
import type { PrintData } from './printService';

/**
 * A screen's own records, made ready for paper.
 *
 * Registers print the rows the module stores, so a stored ISO date would
 * print as `2026-09-14` and a checkbox as `true`. Dates are put in the
 * parish's date format, yes/no fields in words, and every line says who
 * created it — the same things the table on screen shows.
 */
const ISO_DATE = /^\d{4}-\d{2}-\d{2}(T[\d:.]+Z?)?$/;

export const printableRow = (row: object): PrintData => {
  const out: PrintData = {};
  Object.entries(row as PrintData).forEach(([key, value]) => {
    if (typeof value === 'string' && ISO_DATE.test(value)) out[key] = formatDate(value);
    else if (typeof value === 'boolean') out[key] = value ? 'Yes' : 'No';
    else out[key] = value;
  });
  out.createdBy = (row as PrintData).createdBy || '-';
  return out;
};

export const printableRows = (rows: object[]): PrintData[] => rows.map(printableRow);

/** The line under a register's title: what it was filtered by, and when it printed. */
export const printReference = (...parts: Array<string | false | null | undefined>): string =>
  [...parts, `Printed ${formatDate(new Date().toISOString())}`].filter(Boolean).join(' · ');
